import { create } from "zustand";

import type { Tier } from "../components/ui/tier-badge";

type VerifiedStore = {
  // PREVIEW-ONLY control state: no production code writes currentTier (its
  // only setTier callers are dev preview pages), so it sits at the
  // "self-reported" default for real users. Production surfaces must derive
  // the tier from the dashboard snapshot via deriveHighestVerificationTier —
  // reading currentTier on a live surface re-creates the bug where a
  // bank-verified user's readiness hero showed a SELF-REPORTED chip.
  currentTier: Tier;
  verifiedAt: Date | null;
  isExplainerOpen: boolean;

  setTier: (tier: Tier, verifiedAt?: Date | null) => void;
  openExplainer: () => void;
  closeExplainer: () => void;
  reset: () => void;
};

const DEFAULT_STATE = {
  currentTier: "self-reported" as Tier,
  verifiedAt: null,
  isExplainerOpen: false,
};

export const useVerifiedStore = create<VerifiedStore>((set) => ({
  ...DEFAULT_STATE,

  setTier: (tier, verifiedAt = null) => set({ currentTier: tier, verifiedAt }),
  openExplainer: () => set({ isExplainerOpen: true }),
  closeExplainer: () => set({ isExplainerOpen: false }),
  reset: () => set({ ...DEFAULT_STATE }),
}));

export function suggestedUpgrade(tier: Tier): Tier {
  switch (tier) {
    case "self-reported":
      return "document-backed";
    case "document-backed":
      return "bank-verified";
    case "bank-verified":
    case "lender-approved":
      return tier;
  }
}

export function shouldShowStrip(tier: Tier): boolean {
  return tier === "self-reported" || tier === "document-backed";
}

export function canUpgradeToBank(tier: Tier): boolean {
  return tier === "document-backed";
}
